export const BoardQueryKey = {
  BOARD_LIST: "board_list",
  BOARD_DETAIL: "borad_detail",
  BOARD_NEWEST_LIST: "board_newest_list",
};
